import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import {
  SVG_ICON_SIZES,
  SVG_ICON_SIZE_CSS_VAR,
  SvgIconProps,
} from 'components/Luxkit/SvgIcon'
import { getSVGImageUrl } from 'lib/imageUtils'

const LogoImg = styled.img`
  height: var(${SVG_ICON_SIZE_CSS_VAR});
  width: var(${SVG_ICON_SIZE_CSS_VAR});
`

// ToDo: This needs to be cleaned up, perhaps create a LeIcon svg icon properly, spoke to Armin this will be fixed in the coming future
function LeIcon({ size = 24 }: SvgIconProps) {
  const mappedSize = SVG_ICON_SIZES[size] || rem(size)
  return (
    <LogoImg
      src={getSVGImageUrl('logo-LE')}
      alt="LE logo"
      style={{
        [SVG_ICON_SIZE_CSS_VAR as string]: mappedSize,
      }}
    />
  )
}

export default LeIcon
